import * as React from 'react';
import { observer } from 'mobx-react';

import FeaturedProductsQuery from '../../../Query/Products/FeaturedProducts';
import { VariantList, composeDivId } from '../../../../modules/modules';
import { transformProductsToSingleVariant } from '../../../../helpers/products';
import CountryService from '../../../../services/CountryService';
import ReloadPage from '../../../ReloadPage';
import GoogleTagManagerService from '../../../../services/GoogleTagManagerService';
import { canUseDOM } from '../../../../utils';

interface IProductsProps {
  tag: string;
  limit?: number;
  loggedCustomer?: string;
}

@observer
class Products extends React.Component<IProductsProps> {

  public render() {
    const { tag } = this.props;
    const { countryId } = CountryService.GetInstance();

    return (
      <FeaturedProductsQuery 
        tags={[ tag ]} 
        orderBy={'random()'} 
        orderDirection={''} 
        limit={10}
        country={countryId}
        loggedCustomer={this.props.loggedCustomer}
      >
        {({ products }: any) => {
          // in SSR, sometimes query ends with result { loading: true, networkStatus: 1, error: undefined } and no product detail is rendered
          // if that happens, make next attempt to load the page
          if ((global as any).SSR && products.loading) {
            return <ReloadPage />;
          }
          if (!products.loading && products.similarProducts) {
            const variants = transformProductsToSingleVariant(products.similarProducts);

            GoogleTagManagerService.productsInCategory(variants, { pageType: 'home', list: `tag:${tag}`, itemListName: tag });

            return (
              <VariantList
                variants={variants}
                hideTags={[ tag ]}
                GTMItemListName={tag}
              />);
          }

          if (canUseDOM() && ('querySelector' in document)) {
            const ssrVariantList = document.querySelector(`#${composeDivId(tag)}`);
            if (ssrVariantList) {
              const ssrContent = ssrVariantList.innerHTML;
              const ssrClasses = ssrVariantList.className;
              return <div className={ssrClasses} dangerouslySetInnerHTML={{ __html: ssrContent }} />;
            }
          }

          return <div />;
        }}
      </FeaturedProductsQuery>
    );
  }
}

export default Products;


// WEBPACK FOOTER //
// ./src/components/Featured/components/Products/Products.tsx